export enum ConfigManagerProperties {
  AppName = 'appName',
  ApiUrl = 'apiUrl',
  ScopeOptions = 'scopeOptions',
  AppNames = 'appNames',
  SecretToken = 'secretToken',
  SecretTokens = 'secretTokens',
}
